import type { FaireProductEntity } from "../../entity_types/product";

export const p_659wbstpw2: FaireProductEntity = {
  token: "p_659wbstpw2",
  type: "product",
  name: "Mahj Birds Tea Towel",
  brandToken: "b_9n6zhnblbf",
  brandName: "Geometry",
  imageUrl: "https://cdn.faire.com/fastly/d552deb851738b9f45edd32f89ece5d3add35603ca859821e31b78f63141cf61.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/aabc531d94a4a410fc2446c003bf27b5a452486807b51d1a6c72cd1f4e571019.jpeg",
    "https://cdn.faire.com/fastly/60088bd9658540c49c434eb03a3bec554ff4cced8a21102cc255340f6a6fce08.jpeg",
    "https://cdn.faire.com/fastly/b33affd55e8eb31823a694de0b1cc0a4908d91288155880eb4d7ec3c4979a8e7.jpeg",
    "https://cdn.faire.com/fastly/ba68beb3e59059b9e7508c710f6c81c61ff90d17540f0217c7d3423d5baaee56.jpeg",
    "https://cdn.faire.com/fastly/b23d2de9efed2e73c39f1b605c9267dc1b69b0fd9abd5bca40b149e3076d3256.jpeg"
  ],
  priceDollars: 9,
  description: "Kitchen Tea Towel\n\nThrow in the (ordinary) towel. \n\nMeet the product that started it all. The Geometry House Tea Towel is a cult favorite for a reason. Created from a tightly-woven Geoweave™ fabric that is ultra-absorbent, quick-drying and never wrinkles, this towel is built to work – while looking like a dream.\n\n\n...\n\n * ♺ Made from post-consumer recycled materials \n * 18\" x 30\" \n * Single-sided print \n * 100% Satisfaction Guarantee \n * No questions asked, hassle-free returns \n...\n\n\nChore responsibly. \n\nFrom drying dishes to wiping up spills to accenting your kitchen with the season’s most enchanting prints, this Tea Towel does it all – without a negative impact on the environment. Our towels are created from post-consumer recycled products using less water than traditional methods and minimizing our carbon footprint. And due to its patented weave, high absorbency and quick dry time, you can clean with fewer harsh chemicals and wash it less often, reducing yours. \n\nImpact your home, not the environment. Discover the Geometry Tea Towel.\n",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:59:44.524Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
